import { render, staticRenderFns } from "./confirmPassword.vue?vue&type=template&id=8b6bc206"
import script from "./confirmPassword.vue?vue&type=script&lang=js"
export * from "./confirmPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports